// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"944e97be5a4e4f8ca9d5","655":"c4599cb37a6ab1f4c3b3"}[chunkId] + ".js";
};